import axios from "axios";

const url =  "/account/api/v1/company/currency/bulk-update-status";

function bulkUpdateCurrencyConfigStatus({
  currencyCodes, status
}) {
  return new Promise((resolve, reject) => {
    axios.post(url, {
      currencyCodes: currencyCodes,
      status: status
    })
      .then(response => resolve(response))
      .catch(error => reject(error.response.data))
  })
}

export default bulkUpdateCurrencyConfigStatus;